import types from 'redux/types';

const createOffer = (data) => {
  return {
    ...data,
    type: types.REQUEST_CREATE_OFFER,
  };
};

const filterOffer = () => {
  return {
    type: types.REQUEST_FILTER_OFFERS,
  };
};

const getListOffer = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_LIST_OFFER,
  };
};

const getOfferById = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_OFFER_BY_ID,
  };
};

const updateOffer = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_OFFER,
  };
};

const deleteOffer = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_OFFER,
  };
};

const updateOfferCampaign = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_OFFER_CAMPAIGN,
  };
};

const updateDomainCampaign = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_DOMAIN_CAMPAIGN,
  };
};

export default {
  updateDomainCampaign,
  updateOfferCampaign,
  filterOffer,
  updateOffer,
  getListOffer,
  createOffer,
  deleteOffer,
  getOfferById,
};
